import createIcon from './createIcon';
import PencilFilledSvg from './svg/pencil-filled.svg?react';

const PencilFilledIcon = createIcon(PencilFilledSvg);

export default PencilFilledIcon;
